import React, { Fragment, useState } from "react";
import { CSSTransition, TransitionGroup } from "react-transition-group";
import { Row, Col } from "reactstrap";
import DataTable from "react-data-table-component";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import TooltipComponent from "../ReusableComponent/TooltipComponent";
import Delete from "../../assets/images/svg/Delete.svg";
import Edit from "../../assets/images/svg/Edit.svg";
import View from "../../assets/images/svg/View.svg";
import Analysis from "../../assets/images/svg/Analysis.svg";
import download from "../../assets/images/svg/download.svg";

const mapStateToProps = (state) => {
  return {
    reduxData: state.counterSlice,
  };
};

const ErrorTooltip = ({ message, children }) => {
  const [show, setShow] = useState(false);

  return (
    <div
      className="error-tooltip-wrapper"
      onMouseEnter={() => setShow(true)}
      onMouseLeave={() => setShow(false)}
      style={{ position: "relative", display: "inline-block" }}
    >
      {children}
      {show && (
        <div
          className="error-tooltip-box"
          style={{
            position: "absolute",
            bottom: "120%", // show above text
            left: "0",      // start from left
            background: "#333",
            color: "#fff",
            padding: "6px 10px",
            borderRadius: "6px",
            whiteSpace: "nowrap",
            fontSize: "12px",
            zIndex: 999,
          }}
        >
          {message}
        </div>
      )}
    </div>
  );
};

class NetworkTable extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedRows: [],

    };
  }

  handleViewNetwork = (row) => {
    console.log("liof,d j : ", row)
    if (this.props.onView) {
      this.props.onView(row);
    }
  };

  handleFurtherAnalysis = (row) => {
    if (this.props.onAnalysisClick) {
      this.props.onAnalysisClick(row);
    }
  };

  handleDelete = (row) => {
    if (this.props.onDelete) {
      this.props.onDelete(row);
    }
  };

  handleEdit = (row) => {
    if (this.props.onEdit) {
      this.props.onEdit(row);
    }
  };

  handleDownload = (row) => {
    if (this.props.onDownload) {
      this.props.onDownload(row);
    }
  };

  handleRowSelection = ({ selectedRows }) => {
    this.setState({ selectedRows });

    if (this.props.handleRowSelection) {
      this.props.handleRowSelection({ selectedRows });
    }
  };

  toggleTooltip = (key) => {
    this.setState((prevState) => ({
      tooltipOpen: {
        ...prevState.tooltipOpen,
        [key]: !prevState.tooltipOpen[key],
      },
    }));
  };


  render() {
    const { showStatusColumn = true, showViewButton = true } = this.props;
    const loginSubs = this.props?.reduxData?.loginSubscriptionDetail || [];
    const userPlan = (loginSubs.find(item => item.attributes?.active === true) || loginSubs[0])?.attributes?.plan?.toLowerCase();

    const columns = [
      // Conditionally include Status column
      ...(showStatusColumn ? [{
        name: <span className="table-header">Status</span>,
        selector: (row) => row.status,
        sortable: true,
        cell: (row) => (
          <div
            className={`status-badge ${row.status
              .toLowerCase()
              .replace(" ", "-")}`}
          >
            {row.status === "Failed" ? (
              <ErrorTooltip
                message="Network too large to visualize. Please create a subnetwork by adjusting the significance level or selecting a list of genes of interest."
              >
                <span>{row.status}</span>
              </ErrorTooltip>
            ) : (
              <span>{row.status}</span>
            )}
          </div>
        ),
        width: "150px",
      }] : []),
      {
        name: <span className="table-header">{this.props.activeTab === 'projects' ? 'Project Name' : 'Network Name'}</span>,
        selector: (row) => row.networkName,
        cell: (row) => (

          <div className="network-name-container">
            <span className="">{row.networkName}</span>
          </div>

        ),
        sortable: true,
      },
      {
        name: <span className="table-header">Submit Time</span>,
        selector: (row) => row.submitTime,
        sortable: true,
        width: "180px",
      },
      {
        name: <span className="table-header">Actions</span>,
        cell: (row) => (
          <div className="button-group-table">
            {row.status === "Done" && (
              <>
                {showViewButton && (
                  <TooltipComponent
                    id={`tooltip-eye-${row.id}`}
                    tooltipText={row.view_network == false ? "We can’t display this network because it has too many items & exceed the maximum limit of 1000 Nodes & edges. Please apply filters or reduce the data size" : "View Network"}
                  >
                    <img
                      className={`image-icon ${row.view_network == false ? "disabled-icon" : ""}`}
                      src={View}
                      alt=""
                      onClick={() => row.view_network != false && this.handleViewNetwork(row)}
                      style={{
                        cursor: row.view_network == false ? "not-allowed" : "pointer",
                        opacity: row.view_network == false ? 0.5 : 1,
                      }}
                    />
                  </TooltipComponent>
                )}
                <TooltipComponent
                  id={`tooltip-analysis-${row.id}`}
                  tooltipText={
                    userPlan === "bronze"
                      ? "Upgrade your plan to use Further Analysis"
                      : "Further Analysis"
                  }
                >
                  <img
                    src={Analysis}
                    alt=""
                    className={`image-icon ${userPlan === "bronze" ? "disabled-icon" : ""}`}
                    onClick={() =>
                      userPlan !== "bronze" && this.handleFurtherAnalysis(row)
                    }
                    style={{
                      cursor: userPlan === "bronze" ? "not-allowed" : "pointer",
                      opacity: userPlan === "bronze" ? 0.5 : 1,
                    }}
                  />
                </TooltipComponent>
                {/* <TooltipComponent
                  id={`tooltip-analysis-${row.id}`}
                  tooltipText="Further Analysis"
                >
                  <img
                    src={Analysis}
                    alt=""
                    className="image-icon"
                    onClick={() => this.handleFurtherAnalysis(row)}
                  />
                </TooltipComponent> */}
                <TooltipComponent
                  id={`tooltip-download-${row.id}`}
                  tooltipText="Download"
                >
                  <img
                    src={download}
                    alt=""
                    className="image-icon"
                    onClick={() => this.handleDownload(row)}
                  />
                </TooltipComponent>
              </>
            )}
            {(row.status === "Expired" || row.status === "Failed" ||
              row.status === "Running" ||
              row.status === "Done") && (
                <>
                  <TooltipComponent
                    id={`tooltip-edit-${row.id}`}
                    tooltipText="Edit"
                  >
                    <img
                      className="image-icon"
                      src={Edit}
                      alt=""
                      onClick={() => this.handleEdit(row)}
                    />
                  </TooltipComponent>
                  <TooltipComponent
                    id={`tooltip-delete-${row.id}`}
                    tooltipText="Delete"
                  >
                    <img
                      className="image-icon"
                      src={Delete}
                      alt=""
                      onClick={() => this.handleDelete(row)}
                    />
                  </TooltipComponent>
                </>
              )}
          </div>
        ),
        width: "275px",
      },
    ];

    return (
      <>
        <Fragment>
          <TransitionGroup>
            <CSSTransition
              component="div"
              classNames="TabsAnimation"
              appear={true}
              timeout={1500}
              enter={false}
              exit={false}
            >
              <div>
                <Row>
                  <Col md="12">
                    <DataTable
                      columns={columns}
                      data={this.props.networkDetails}
                      selectableRows
                      selectableRowDisabled={(row) =>
                        row.status !== "Done"
                      }
                      onSelectedRowsChange={this.handleRowSelection}
                      pagination // enable pagination
                      paginationServer // enable server-side pagination
                      paginationTotalRows={this.props.total} // total number of rows
                      paginationPerPage={this.props.pageSize} // number of items per page
                      paginationDefaultPage={this.props.page}
                      paginationRowsPerPageOptions={[10, 50, 100]} // pagination options
                      onChangePage={this.props.onPageChange} // handle page change
                      onChangeRowsPerPage={this.props.onRowsPerPageChange} // fetch first page with new page size
                    />
                  </Col>
                </Row>
              </div>
            </CSSTransition>
          </TransitionGroup>
        </Fragment>
      </>
    );
  }
}

export default connect(mapStateToProps)(withRouter(NetworkTable)); // Wrap withRouter
